export type ShoppingListStatus = 'not_started' | 'active' | 'paused' | 'completed';

export interface ShoppingList {
  id: number;
  name: string;
  description?: string | null;
  status: ShoppingListStatus;
  shop?: number | null;
  shop_name?: string | null;
  completed: boolean;
  completed_at_shop?: number | null;
  completed_at_shop_name?: string | null;
  completed_at?: string | null;
  duplicated_from?: number | null;
  duplicated_from_name?: string | null;
  duplicated_from_deleted?: boolean | null;
  item_count?: number;
  item_count_all?: number;
  picked_count?: number;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  deleted?: boolean;
}

export interface ShoppingListFormData {
  name: string;
  description: string;
}

export const emptyShoppingListFormData: ShoppingListFormData = {
  name: '',
  description: '',
};